// extracted by mini-css-extract-plugin
export default {"notFound":"notFoundPage_notFound__Hfck4","nfMiddle":"notFoundPage_nfMiddle__kDcHH"};